import {
  Button,
  Image,
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react"
import React from "react"

export function ViewImage({ image }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Image
        src={image ? image : "https://via.placeholder.com/150"}
        fallbackSrc="https://via.placeholder.com/150"
        w={150}
        h={150}
        border={"1px solid #ccc"}
        p={2}
        onClick={onOpen}
        cursor={"pointer"}
      />
      <ChakraModal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Foto do canhoto</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Image
              src={image}
              fallbackSrc="https://via.placeholder.com/150"
              w={"100%"}
              border={"1px solid #ccc"}
              p={2}
            />
          </ModalBody>

          <ModalFooter display="flex" justifyContent="center" alignItems="center">
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </ChakraModal>
    </>
  )
}
